import { Seo } from "@/components/Seo";
import { Reveal, HoldingsWordmark } from "@/components/primitives";

const S = ({ n, title, children }) => (
  <Reveal>
    <div className="mb-8">
      <h3 className="font-display uppercase tracking-wide2 text-base md:text-lg gold-text">{n}. {title}</h3>
      <div className="mt-3 space-y-3 text-[var(--bone)]/85 leading-relaxed">{children}</div>
    </div>
  </Reveal>
);

export default function Terms() {
  return (
    <div className="glow-black min-h-screen">
      <Seo title="Terms and Conditions" description="Terms and Conditions for Jennae Michelle Holdings LLC." />
      <section className="pt-28 md:pt-36 pb-8 px-6">
        <div className="max-w-3xl mx-auto">
          <Reveal className="text-center mb-8">
            <p className="font-display uppercase tracking-luxe text-xs text-[var(--muted)] mb-8">Terms and Conditions</p>
            <HoldingsWordmark size="md" />
          </Reveal>
        </div>
      </section>

      <section className="pb-20 px-6">
        <div className="max-w-3xl mx-auto border border-[rgba(180,139,63,0.18)] px-6 md:px-10 py-10">
          <Reveal>
            <p className="text-[var(--bone)]/85 mb-8">
              <strong className="font-display uppercase tracking-wide2 text-sm gold-text">Terms and Conditions</strong><br />
              Effective Date: 3/10/2026<br />Company Name: Jennae Michelle Holdings LLC
            </p>
          </Reveal>

          <S n="1" title="Use of Services">
            <p>By accessing or using our services, you agree to these Terms and Conditions.</p>
            <p>You agree to use our services only for lawful purposes.</p>
          </S>
          <S n="2" title="SMS Messaging Terms">
            <p>By providing your phone number or contacting us, you consent to receive SMS messages.</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Message frequency varies</li>
              <li>Message and data rates may apply</li>
              <li>Reply STOP to unsubscribe</li>
              <li>Reply HELP for assistance</li>
            </ul>
          </S>
          <S n="3" title="No Guarantee of Services">
            <p>We do not guarantee outcomes, offers, or results from any communication or inquiry.</p>
            <p>All interactions are informational and subject to further review.</p>
          </S>
          <S n="4" title="User Responsibility">
            <p>You agree that any information you provide is accurate and truthful.</p>
          </S>
          <S n="5" title="Limitation of Liability">
            <p>We are not liable for:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Any damages arising from use of our services</li>
              <li>Delays or failures in communication</li>
              <li>Third-party service interruptions</li>
            </ul>
          </S>
          <S n="6" title="Intellectual Property">
            <p>All content, branding, and materials are owned by Jennae Michelle Holdings LLC and may not be used without permission.</p>
          </S>
          <S n="7" title="Modifications">
            <p>We may update these Terms at any time. Continued use of our services constitutes acceptance of updates.</p>
          </S>
          <S n="8" title="Contact Information">
            <p>For questions, contact:</p>
            <p>Email: <a href="mailto:admin@jennaemichelle.com" className="gold-text link-underline">admin@jennaemichelle.com</a></p>
          </S>
        </div>
      </section>
    </div>
  );
}
